import { c as _c } from "react/compiler-runtime";
import { ReactNode } from "react";
import { ListFilter } from "lucide-react";
import { GlassIconButton } from "@/components/atoms/GlassIconButton";
import { FilterConfig } from "../../schemas";
import { MobileFilterCategoryList } from "../../FilterMenuList/MobileFilterCategoryList/MobileFilterCategoryList";
import { useTranslations } from "next-intl";
import { useModal, ModalTypeEnum } from "@/components/providers/modal-provider/ModalProvider";
import { useMobileFilterOrchestrator } from "./useMobileFilterOrchestrator";
type Props = {
  filters: FilterConfig[];
  pageKey: string;
  mobileHeader?: ReactNode;
};
export function MobileFilterOrchestrator(t0) {
  const $ = _c(14);
  const {
    filters,
    pageKey,
    mobileHeader
  } = t0;
  const t = useTranslations("modules.listings.listingsPage.filters");
  const {
    openModal
  } = useModal();
  const {
    totalActiveFilters
  } = useMobileFilterOrchestrator(pageKey);
  let t1;
  if ($[0] !== filters || $[1] !== mobileHeader || $[2] !== openModal || $[3] !== pageKey || $[4] !== t) {
    t1 = () => {
      openModal(ModalTypeEnum.GENERIC_SHEET, {
        title: t("mobileTitle"),
        side: "bottom",
        className: "h-dvh flex flex-col",
        children: <MobileFilterCategoryList filters={filters} pageKey={pageKey} mobileHeader={mobileHeader} />
      });
    };
    $[0] = filters;
    $[1] = mobileHeader;
    $[2] = openModal;
    $[3] = pageKey;
    $[4] = t;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const handleOpen = t1;
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ListFilter data-sentry-element="ListFilter" data-sentry-source-file="MobileFilterOrchestrator.tsx" />;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== handleOpen) {
    t3 = <GlassIconButton onClick={handleOpen} data-sentry-element="GlassIconButton" data-sentry-source-file="MobileFilterOrchestrator.tsx">{t2}</GlassIconButton>;
    $[7] = handleOpen;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== totalActiveFilters) {
    t4 = totalActiveFilters > 0 && <span className="absolute -top-1 -right-1 inline-flex items-center justify-center rounded-full bg-foreground text-background text-[10px] w-4 h-4 shrink-0">{totalActiveFilters}</span>;
    $[9] = totalActiveFilters;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = <div className="relative" data-sentry-component="MobileFilterOrchestrator" data-sentry-source-file="MobileFilterOrchestrator.tsx">{t3}{t4}</div>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}